import { BuilderItem } from "../interfaces/builder-item";
import { Address } from "./address";

export class Builder implements BuilderItem {
    id!: number;
    name!: string;
    address!: Address;
    phoneNumber!: string;
}
